import styled from "styled-components";

export const FilterContainer = styled.header`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 0.6fr 0.6fr 0.5fr;
  gap: 2rem;
  margin-bottom: 32px;
  align-items: flex-end;
  background: white;
  padding: 18px 16px;
  border-radius: 8px;
  & > div {
    grid-column: span 1;
  }
`;
